import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export const routesWithTitles = [
  { path: '/login', title: 'My Brightspeed - Login' },
  { path: '/login-password', title: 'My Brightspeed - Login' },
  { path: '/signUp', title: 'My Brightspeed - Create account' },
  { path: '/new-forget-username', title: 'My Brightspeed - Forget username' },
  { path: '/new-forget-password', title: 'My Brightspeed - Forget Password' },
  { path: '/find-username', title: 'My Brightspeed - Forgot username' },
  { path: '/home ', title: 'My Brightspeed - Home' },
  { path: '/view-payments', title: 'My Brightspeed - View payments' },
  { path: '/payment-methods', title: 'My Brightspeed - Payment methods' },
  { path: '/account-info', title: 'My Brightspeed - Account settings' },
  { path: '/plan-details', title: 'My Brightspeed - Plan details' },
  { path: '/shop-exp', title: 'My Brightspeed - Change your plan' },
  { path: '/update-plan', title: 'My Brightspeed - Change your plan' },
  { path: '/network-info ', title: 'My Brightspeed - Network settings' },
  { path: '/help-and-support ', title: 'My Brightspeed - We’re here to help' },
  { path: '/appointments ', title: 'My Brightspeed - Appointments' },
];

const getPageTitle = (pathname: string) => {
  const route = routesWithTitles.find(r => pathname?.includes(r.path.trim()));
  return route ? route.title : 'My Brightspeed';
};

const PageTitleChanger: React.FC = () => {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');
  const isPageReload = useRef<boolean>(false);

  // Determine if the page was reloaded
  useEffect(() => {
    const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    isPageReload.current = navEntry?.type === 'reload'
  }, []);

  useEffect(() => {
    const title = getPageTitle(location.pathname);
    document.title = title;

    if (isPageReload.current) {
      isPageReload.current = false; // reset so future route changes will trigger
      return;
    }

    const timeout = setTimeout(() => {
      setAnnouncement(title);
    }, 100);
    return ()=> clearTimeout(timeout);
  }, [location.pathname]);

  const pageTitle = getPageTitle(location.pathname);

  return (
    <>
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
      <div
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          margin: '-1px',
          border: '0',
          padding: '0',
          clip: 'rect(0 0 0 0)',
          overflow: 'hidden',
        }}
      >
        {announcement}
      </div>
    </>
  );
};

export default PageTitleChanger;